import styled, { keyframes } from 'styled-components';

const progressAnimation = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

export const StyledCsvUpload = styled.div`


  height: calc(100vh - 60px);
  padding: 20px;
  display: flex;
  align-items:center;
justify-content:center;

  .csv-upload-container{
    width: 100%;
    max-width: 900px;

.fields-wrapper-holder{
  height: calc(100vh - 430px);
}

.columns{
  height: calc(100vh - 509px) !important;

}

  }

  .page-title {
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    color: var(--secondary);
    margin: 0 0 8px;
  }

  .page-subtitle {
    font-size: 14px;
    line-height: 18px;
    color: var(--light-gray);
    margin: 0 0 30px;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  gap: 20px;
`;

export const StepItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  background-color: ${({ $isActive }) =>
    $isActive ? 'var(--blue)' : 'var(--gray-150)'};
  color: ${({ $isActive }) => ($isActive ? 'white' : 'var(--light-gray)')};
`;

export const StepLabel = styled.span`
  color: ${({ $isActive }) =>
    $isActive ? 'var(--secondary)' : 'var(--light-gray)'};
  font-weight: ${({ $isCurrent }) => ($isCurrent ? 600 : 400)};
`;

export const StepConnector = styled.div`
  width: 40px;
  height: 2px;
  background-color: ${({ $isActive }) =>
    $isActive ? 'var(--blue)' : 'var(--gray-150)'};
  margin-top: 15px;
`;

export const SectionHeader = styled.div`
  margin-bottom: 20px;

  .section-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: var(--secondary);
  }

  .section-subtitle {
    font-size: 14px;
    color: var(--light-gray);
    margin: 0;
  }
`;

export const ProgressSection = styled.div`
  margin: 24px 0;
  padding: 20px;
  background: var(--gray);
  border-radius: 12px;
  border: 1px solid var(--gray-150);

  .progress-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: var(--secondary);
    margin-bottom: 12px;
  }

  .progress-bar-wrapper {
    width: 100%;
    height: 10px;
    background: var(--gray-150);
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 8px;
  }

  .progress-bar-fill {
    height: 100%;
    border-radius: 10px;
    background: linear-gradient(90deg, #247df3 0%, #04c8fe 100%);
    transition: width 0.4s ease;
    background-size: 200% 200%;
    animation: ${progressAnimation} 2s linear infinite;
  }

  .progress-message {
    font-size: 13px;
    color: var(--light-gray);
  }

  .status-info {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    font-size: 13px;
    color: var(--secondary);

    .status-badge {
      padding: 4px 10px;
      border-radius: 50px;
      font-size: 12px;
      font-weight: 600;
      text-transform: capitalize;

      &.processing {
        color: #2cccff;
        background: rgba(44, 204, 255, 0.12);
      }
      &.completed {
        color: #47c500;
        background: rgba(78, 210, 3, 0.12);
      }
      &.failed {
        color: #fe3839;
        background: rgba(254, 56, 57, 0.12);
      }
    }
  }
`;

export const ActionBar = styled.div`
  display: flex;
  justify-content: ${({ $align }) => $align || 'flex-end'};
  gap: 12px;
  margin-top: 24px;
`;

export const AccessDenied = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
  text-align: center;

  .lock-icon {
    font-size: 60px;
    margin-bottom: 16px;
  }

  .denied-title {
    font-size: 22px;
    font-weight: 700;
    color: var(--secondary);
    margin-bottom: 8px;
  }

  .denied-text {
    font-size: 14px;
    color: var(--light-gray);
  }
`;
